import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const CustdataAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		loanid: yup.string().required().label($t('loanid')),
		customerid: yup.string().nullable().label($t('customerid')),
		customername: yup.string().nullable().label($t('customername')),
		dob: yup.string().nullable().label($t('dob')),
		pancard: yup.string().nullable().label($t('pancard')),
		principal: yup.number().nullable().label($t('principal')),
		interest_fee: yup.number().nullable().label($t('interestFee')),
		service_fee: yup.number().nullable().label($t('serviceFee')),
		service_fee_gst: yup.number().nullable().label($t('serviceFeeGst')),
		late_payment_fee: yup.number().nullable().label($t('latePaymentFee')),
		late_payment_gst: yup.number().nullable().label($t('latePaymentGst')),
		total: yup.number().nullable().label($t('total')),
		mobileno: yup.number().nullable().label($t('mobileno')),
		email: yup.string().email().nullable().label($t('email')),
		address: yup.string().nullable().label($t('address')),
		state: yup.string().nullable().label($t('state')),
		giveoutdate: yup.string().nullable().label($t('giveoutdate')),
		sanction_amt: yup.number().nullable().label($t('sanctionAmt'))
	});
	
	//form default values
	const formDefaultValues = {
		loanid: '', 
		customerid: '', 
		customername: '', 
		dob: '', 
		pancard: '', 
		principal: '', 
		interest_fee: '', 
		service_fee: '', 
		service_fee_gst: '', 
		late_payment_fee: '', 
		late_payment_gst: '', 
		total: '', 
		mobileno: '', 
		email: '', 
		address: '', 
		state: '', 
		giveoutdate: new Date(), 
		sanction_amt: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/custdata`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="CustdataAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewCustdata')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('loanid')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="loanid"  onChange={formik.handleChange}  value={formik.values.loanid}   label={$t('loanid')} type="text" placeholder={$t('enterLoanid')}        className={inputClassName(formik?.errors?.loanid)} />
                                                <ErrorMessage name="loanid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('customerid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="customerid"  onChange={formik.handleChange}  value={formik.values.customerid}   label={$t('customerid')} type="text" placeholder={$t('enterCustomerid')}        className={inputClassName(formik?.errors?.customerid)} />
                                                <ErrorMessage name="customerid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('customername')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="customername"  onChange={formik.handleChange}  value={formik.values.customername}   label={$t('customername')} type="text" placeholder={$t('enterCustomername')}        className={inputClassName(formik?.errors?.customername)} />
                                                <ErrorMessage name="customername" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('dob')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="dob"  onChange={formik.handleChange}  value={formik.values.dob}   label={$t('dob')} type="text" placeholder={$t('enterDob')}        className={inputClassName(formik?.errors?.dob)} />
                                                <ErrorMessage name="dob" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('pancard')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pancard"  onChange={formik.handleChange}  value={formik.values.pancard}   label={$t('pancard')} type="text" placeholder={$t('enterPancard')}        className={inputClassName(formik?.errors?.pancard)} />
                                                <ErrorMessage name="pancard" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('principal')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="principal"  onChange={formik.handleChange}  value={formik.values.principal}   label={$t('principal')} type="number" placeholder={$t('enterPrincipal')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.principal)} />
                                                <ErrorMessage name="principal" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('interestFee')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="interest_fee"  onChange={formik.handleChange}  value={formik.values.interest_fee}   label={$t('interestFee')} type="number" placeholder={$t('enterInterestFee')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.interest_fee)} />
                                                <ErrorMessage name="interest_fee" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('serviceFee')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="service_fee"  onChange={formik.handleChange}  value={formik.values.service_fee}   label={$t('serviceFee')} type="number" placeholder={$t('enterServiceFee')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.service_fee)} />
                                                <ErrorMessage name="service_fee" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('serviceFeeGst')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="service_fee_gst"  onChange={formik.handleChange}  value={formik.values.service_fee_gst}   label={$t('serviceFeeGst')} type="number" placeholder={$t('enterServiceFeeGst')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.service_fee_gst)} />
                                                <ErrorMessage name="service_fee_gst" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('latePaymentFee')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="late_payment_fee"  onChange={formik.handleChange}  value={formik.values.late_payment_fee}   label={$t('latePaymentFee')} type="number" placeholder={$t('enterLatePaymentFee')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.late_payment_fee)} />
                                                <ErrorMessage name="late_payment_fee" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('latePaymentGst')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="late_payment_gst"  onChange={formik.handleChange}  value={formik.values.late_payment_gst}   label={$t('latePaymentGst')} type="number" placeholder={$t('enterLatePaymentGst')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.late_payment_gst)} />
                                                <ErrorMessage name="late_payment_gst" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('total')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="total"  onChange={formik.handleChange}  value={formik.values.total}   label={$t('total')} type="number" placeholder={$t('enterTotal')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.total)} />
                                                <ErrorMessage name="total" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mobileno')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="mobileno"  onChange={formik.handleChange}  value={formik.values.mobileno}   label={$t('mobileno')} type="number" placeholder={$t('enterMobileno')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.mobileno)} />
                                                <ErrorMessage name="mobileno" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('email')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="email"  onChange={formik.handleChange}  value={formik.values.email}   label={$t('email')} type="email" placeholder={$t('enterEmail')}        className={inputClassName(formik?.errors?.email)} />
                                                <ErrorMessage name="email" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('address')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="address"  onChange={formik.handleChange}  value={formik.values.address}   label={$t('address')} type="text" placeholder={$t('enterAddress')}        className={inputClassName(formik?.errors?.address)} />
                                                <ErrorMessage name="address" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('state')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="state"  onChange={formik.handleChange}  value={formik.values.state}   label={$t('state')} type="text" placeholder={$t('enterState')}        className={inputClassName(formik?.errors?.state)} />
                                                <ErrorMessage name="state" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('giveoutdate')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="giveoutdate" value={formik.values.giveoutdate} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.giveoutdate)}        />
                                                <ErrorMessage name="giveoutdate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('sanctionAmt')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="sanction_amt"  onChange={formik.handleChange}  value={formik.values.sanction_amt}   label={$t('sanctionAmt')} type="number" placeholder={$t('enterSanctionAmt')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.sanction_amt)} />
                                                <ErrorMessage name="sanction_amt" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
CustdataAddPage.defaultProps = {
	primaryKey: 'loanid',
	pageName: 'custdata',
	apiPath: 'custdata/add',
	routeName: 'custdataadd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default CustdataAddPage;
